export const INPUT_NAMES = {
  name: 'nameRef',
  address: 'addressRef',
  phone: 'phoneRef',
  site: 'siteRef',
  isBlocked: 'isBlockedRef',
  status: 'statusRef',
  partner: 'partnerRef',
  inn: 'innRef',
  blockDate: 'blockDateRef',
  packageCount: 'packageCountRef',
  tariffId: 'tariffIdRef',
  subscriptionType: 'subscriptionTypeRef',
  useCustomTariff: 'useCustomTariffRef',
  customTariffReportCount: 'reportCountRef',
  customTariffPriceMonth: 'priceMonthRef',
  customTariffPriceYear: 'priceYearRef',
  customTariffPriceOver: 'priceOverRef',
  dealDate: 'dealDateRef',
} as const
